/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Hotkey: ()=>Hotkey
});
const external_delay_namespaceObject = require("delay");
var external_delay_default = /*#__PURE__*/ __webpack_require__.n(external_delay_namespaceObject);
const logger_namespaceObject = require("@agent-infra/logger");
const external_key_map_js_namespaceObject = require("./key-map.js");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class Hotkey {
    formatHotkey(hotkey) {
        const lowerCaseHotkey = hotkey.toLowerCase();
        const keys = lowerCaseHotkey.split(/[\s+]+/);
        this.logger.info('lowerCase keys', keys);
        const formattedKeys = keys.map((key)=>{
            if (external_key_map_js_namespaceObject.KEY_ABBR_TO_STANDARD_MAP[key]) return external_key_map_js_namespaceObject.KEY_ABBR_TO_STANDARD_MAP[key];
            if (external_key_map_js_namespaceObject.KEY_LOW_TO_STANDARD_MAP[key]) return external_key_map_js_namespaceObject.KEY_LOW_TO_STANDARD_MAP[key];
            throw new Error('Unsupported key: ' + key);
        });
        this.logger.info('format keys', formattedKeys);
        return formattedKeys;
    }
    async macOSCDPHotKey(page, keys, options) {
        const hotkey = keys.map((key)=>{
            if ('Control' === key || 'Meta' === key) return 'CorM';
            return key;
        }).join('+');
        const command = external_key_map_js_namespaceObject.MAC_SYSTEM_HOTKEY_MAP.get(hotkey);
        if (command) {
            await page.keyboard.down(command.key, {
                commands: [
                    command.commands
                ]
            });
            await external_delay_default()(options.delay);
            await page.keyboard.up(command.key);
            return true;
        }
        return false;
    }
    async press(page, hotkey, options = {
        delay: 100
    }) {
        const formattedHotkey = this.formatHotkey(hotkey);
        if ('macOS' === this.osName && 'Chrome' === this.browserName) {
            const success = await this.macOSCDPHotKey(page, formattedHotkey, options);
            if (success) return;
        }
        for (const key of formattedHotkey)await page.keyboard.down(key);
        await external_delay_default()(options.delay);
        for (const key of formattedHotkey.reverse())await page.keyboard.up(key);
    }
    async down(page, hotkey, options = {
        delay: 100
    }) {
        const formattedHotkey = this.formatHotkey(hotkey);
        if ('macOS' === this.osName && 'Chrome' === this.browserName) {
            const success = await this.macOSCDPHotKey(page, formattedHotkey, options);
            if (success) return;
        }
        for (const key of formattedHotkey)await page.keyboard.down(key);
    }
    async up(page, hotkey, options = {
        delay: 100
    }) {
        const formattedHotkey = this.formatHotkey(hotkey);
        for (const key of formattedHotkey.reverse())await page.keyboard.up(key);
    }
    constructor(envInfo, logger){
        _define_property(this, "osName", void 0);
        _define_property(this, "browserName", void 0);
        _define_property(this, "logger", void 0);
        this.osName = envInfo.osName;
        this.browserName = envInfo.browserName;
        this.logger = logger ?? new logger_namespaceObject.ConsoleLogger('Hotkey:');
    }
}
exports.Hotkey = __webpack_exports__.Hotkey;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Hotkey"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});

//# sourceMappingURL=index.js.map